module.exports = __webpack_public_path__ + "img/zhibo.6e63e416.png";